import { api } from "src/Basic/ApiFetch";
import { showGlobalMessageBox, getGlobalServerConfig } from "src/Route/RootMiddleware";

export const DropDown = {
    /**
     * 取得縣市清單
     * @returns 
     */
    getCountyList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCountyList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇縣市" });
                return data;
            }
        }
    },
    /**
     * 取得鄉鎮市清單
     * @param {*} countyCode 
     * @returns 
     */
    getTownList: async (countyCode) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetTownList/' + countyCode;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇鄉鎮市區" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得國籍清單
     * @param filterTW 預設true(排除台灣)
     * @returns 
     */
    getCountryList: async (isReturnPromise = false, filterTW = true) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCountryList?filterTW=' + filterTW;
        let response = await api.Get(url, null, null, false);
        if (isReturnPromise) {
            return response;
        }

        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇國家" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得幣別清單
     * @returns 
     */
    getCurrencyList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/getCurrencyList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: null, text: "請選擇幣別" }); 
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    getInvestorTypeList: async () => {
        let url = `${getGlobalServerConfig().backEndUrl.get()}DropDown/GetInvestorTypeList/`;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇投資人型態" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    getInvestorTypeList: async () => {
        let url = `${getGlobalServerConfig().backEndUrl.get()}DropDown/GetInvestorTypeList/`;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇投資人型態" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    getInvestorNameList: async (SRNO1) => {

        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetInvestorNameList/' + SRNO1;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得縣、州清單
     * @returns 
     */
    GetCountyListByCountryCode: async (countryCode) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCountyListByCountryCode/' + countryCode;
        let response = await api.Get(url, null, null, false);
        let data = {};
        if (response.ok) {
            data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇縣(州)" });
            }
            else {
                data.unshift({ value: "", text: "本欄免填" });
            }
            return data;
        }
    },
    /**
     * 取得對外(港澳)(大陸)投資事業營業項目
     * @returns 
     */
    getBusinessBizItemList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetBusinessBizItemList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇營業項目" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得省清單
     * @returns 
     */
    getProvList: async (isReturnPromise = false) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetProvList';
        let response = await api.Get(url, null, null, false);
        if (isReturnPromise) {
            return response;
        }

        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇省" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得市清單
     * @returns 
     */
    getCityList: async (provCode) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCityCode/' + provCode;
        let response = await api.Get(url, null, null, false);
        let data = {};
        if (response.ok) {
            data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇市" });
                return data;
            }
        }
    },
    /**
     * 取得對大陸投資事業 所有經營業務-營業項目
     * @returns 
     */
    getBusinessBizItemCccStandardList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetBusinessBizItemCccStandardList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得投資型態清單
     * @returns 
     */
    getInvestorInvestTypeList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetInvestorInvestTypeList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇投資型態" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
        else {
            showGlobalMessageBox("系統發生錯誤請聯繫管理員");
        }
    },
    /**
     * 取得投資項目清單
     * @returns 
     */
    getInvestItemList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetInvestItemList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇投資項目" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
        else {
            showGlobalMessageBox("系統發生錯誤請聯繫管理員");
        }
    },
    /**
     * 取得事業名稱限制清單
     * @returns 
     */
    getProhibitInvestCompList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetProhibitInvestCompList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 
     * @returns 
     */
    GetCaseNoType: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCaseNoType';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得國籍限制清單
     * @returns 
     */
    getProhibitInvestCountryList: async (isReturnPromise = false) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetProhibitInvestCountryList';
        let response = await api.Get(url, null, null, false);
        if (isReturnPromise) {
            return response;
        }
       if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得案由清單
     * @returns 
     */
    GetCaseReasonList: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCaseReasonList';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇案由" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },

    /**
     * 取得大陸地區省份清單
     * @returns
     */
    GetCnProvince: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetCnProvince';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得減資類型清單
     * @returns
     */
    GetHandlingMethod: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetHandlingMethod';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: "", text: "請選擇方式" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    /**
     * 取得出資種類清單
     * @returns
     */
    GetRegiType: async () => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetRegiType';
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            if (data && Object.keys(data).length > 0) {
                data.unshift({ value: null, text: "請選擇方式" });
                return data;
            } else {
                showGlobalMessageBox("系統發生錯誤請聯繫管理員");
            }
        }
    },
    getInvestorInfForeignList: async (SRNO1) => {
        let url = getGlobalServerConfig().backEndUrl.get() + 'DropDown/GetPrInvestorInfForeignList/' + SRNO1;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            data.unshift({ text: "請選擇", value: 0 });
            data = data.map(item => ({
                ...item,
                value: parseInt(item.value, 10)
            }));
            return data;
        }
        else {
            showGlobalMessageBox("系統發生錯誤請聯繫管理員");
        }
    },
    getPrThirdBusinessList: async (SRNO1) => {
        let url = getGlobalServerConfig().backEndUrl.get() + "DropDown/GetPrThirdBusinessList/" + SRNO1;
        let response = await api.Get(url, null, null, false);
        if (response.ok) {
            let data = await response.json();
            data.unshift({ text: "請選擇", value: 0 });
            data = data.map(item => ({
                ...item,
                value: parseInt(item.value, 10)
            }));
            return data;
        }
    }
};

